import $ from "jquery";
require('./assets/js/jquery-global');
import 'bootstrap'
import Readmore from 'readmore-js';

import 'slick-carousel';
import styles from '/assets/scss/app.scss';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import scripts from '/assets/js/app.js';

require('./assets/js/jquery-template');


require('./assets/js/lwsreviews-feed');
require('./assets/js/vue/app');
require('./assets/js/cookie');

